import axios from "axios";
import { useQuery } from "react-query";

export const useGetLensMeta = () => {
  return useQuery(
    "lensMeta",
    () => axios.get("/api/lenses/meta").then((r) => r.data),
    { staleTime: 5 * 60 * 1000 }
  );
};

export const useGetLensOverview = ({ period, locality, enabled = true }) => {
  return useQuery(
    ["lensOverview", period, locality],
    () =>
      axios
        .get("/api/lenses/overview", { params: { period, locality } })
        .then((r) => r.data),
    { staleTime: 2 * 60 * 1000, enabled }
  );
};

export const useGetTeamLens = ({ team, period, view, locality, enabled = true }) => {
  return useQuery(
    ["lensTeam", team, period, view, locality],
    () =>
      axios
        .get("/api/lenses/team", { params: { team, period, view, locality } })
        .then((r) => r.data),
    { staleTime: 2 * 60 * 1000, enabled }
  );
};

export const useGetTopicsLens = ({ period, locality, enabled = true }) => {
  return useQuery(
    ["lensTopics", period, locality],
    () =>
      axios
        .get("/api/lenses/topics", { params: { period, locality } })
        .then((r) => r.data),
    { staleTime: 2 * 60 * 1000, enabled }
  );
};

export const useGetFeatureHealth = ({ period, locality, enabled = true }) => {
  return useQuery(
    ["lensFeatures", period, locality],
    () =>
      axios
        .get("/api/lenses/features", { params: { period, locality } })
        .then((r) => r.data),
    { staleTime: 2 * 60 * 1000, enabled }
  );
};

export const useGetSegmentLens = ({ dimension, period, attribute, enabled = true }) => {
  return useQuery(
    ["lensSegments", dimension, period, attribute],
    () =>
      axios
        .get("/api/lenses/segments", { params: { dimension, period, attribute } })
        .then((r) => r.data),
    { staleTime: 2 * 60 * 1000, enabled }
  );
};

export const useGetSignalsLens = ({ period, locality, enabled = true }) => {
  return useQuery(
    ["lensSignals", period, locality],
    () =>
      axios
        .get("/api/lenses/signals", { params: { period, locality } })
        .then((r) => r.data),
    { staleTime: 2 * 60 * 1000, enabled }
  );
};

export const useGetOverviewDetail = ({ cardId, period, locality, enabled = true }) => {
  return useQuery(
    ["lensOverviewDetail", cardId, period, locality],
    () =>
      axios
        .get("/api/lenses/overview-detail", { params: { cardId, period, locality } })
        .then((r) => r.data),
    { staleTime: 2 * 60 * 1000, enabled: enabled && !!cardId }
  );
};

export const useGetSignalDetail = ({ signalTag, period, locality, enabled = true }) => {
  return useQuery(
    ["lensSignalDetail", signalTag, period, locality],
    () =>
      axios
        .get("/api/lenses/signal-detail", { params: { signalTag, period, locality } })
        .then((r) => r.data),
    { staleTime: 2 * 60 * 1000, enabled: enabled && !!signalTag }
  );
};

export const useGetSignalThemeDetail = ({ signalTag, themeId, themeType, period, enabled = true }) => {
  return useQuery(
    ["lensSignalThemeDetail", signalTag, themeId, themeType, period],
    () =>
      axios
        .get("/api/lenses/signal-theme-detail", { params: { signalTag, themeId, themeType, period } })
        .then((r) => r.data),
    { staleTime: 2 * 60 * 1000, enabled: enabled && !!signalTag && !!themeId }
  );
};

export const useGetTagDetail = ({ tagId, period, mode, locality, enabled = true }) => {
  return useQuery(
    ["lensTagDetail", tagId, period, mode, locality],
    () =>
      axios
        .get("/api/lenses/tag-detail", { params: { tagId, period, mode, locality } })
        .then((r) => r.data),
    { staleTime: 2 * 60 * 1000, enabled: enabled && !!tagId }
  );
};
